import { useNavigate, useLocation } from 'react-router-dom';

import {
  getParsedRedirects,
  updateSessionStorage,
} from 'hooks/useRedirect/utils';
import useSnackbar from 'hooks/useSnackbar';

/**
 * @returns redirect - Wrapper function for navigate
 * @returns consoleRedirectStack - A global function that is a part of the
 * window object which prints the current session's redirect stack
 */
const useRedirect = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { setSnackbarMessage } = useSnackbar();

  /**
   * @param reason - The reason for the redirection
   * @param component - The name of the component that is calling this method
   * @param to - The route or delta value to redirect to
   * @param options - Optional navigate params
   */
  const redirect = ({ reason, component, to, options = {} }) => {
    if (!reason || !to || !component) {
      setSnackbarMessage({
        message:
          'Must provide a route path, reason for redirection, and the current component name',
        variant: 'error',
      });
      return;
    }
    updateSessionStorage({ to, reason, component, pathname });
    navigate(to, options);
  };

  const consoleRedirectStack = () => {
    const parsedRedirects = getParsedRedirects();
    console.info(
      '%cOrdered in chronological order (oldest record at the top)',
      'color:purple',
    );
    parsedRedirects.forEach(
      ({ component, to, reason, pathname: pn, timestamp }) =>
        console.info(
          `${timestamp} | %c${component} %credirected from %c${pn} %cto %c${to} %cbecause %c"${reason}"`,
          'color: green',
          'color: black',
          'color: green',
          'color: black',
          'color: green',
          'color: black',
          'color: green',
        ),
    );
  };

  window.consoleRedirectStack = consoleRedirectStack;

  return { redirect };
};

export default useRedirect;
